import {
    each
} from "App/lib/util";
import DomComponent from "../../lib/domComponent";
const FILTER_SELECTOR = "[data-filter]";
const RESET_SELECTOR = "[data-reset]";

export default class Filters extends DomComponent {
    static selector = "[data-js-filters]";
    model = {};

    constructor(el, opts) {
        super(el);

        this.$filters = $(el).find(FILTER_SELECTOR);
        this.$reset = $(el).find(RESET_SELECTOR);

        this.onFilter = opts.onFilter;
        this.onReset = opts.onReset;

        this.$reset.on('click', this.reset.bind(this));

        this.eachFilterInput((input, filter, filterKey, filterName) => {

            $(input).on('change', (e) => {
                const filterValue = input.value;
                const valueLabel = $(input).data('value-label');

                const type = input.type;
                let action = 'set';

                if (type === 'checkbox') {
                    action = input.checked ? 'add' : 'remove';
                }
                //update active filter list on breadcrumbs
                this.updateActiveFilters(filterName, filterValue, action, valueLabel);

                this.onFilter(filterKey, filterValue, action);
            })
        });

    }

    updateActiveFilters(name, value, action, valueLabel) {
        if (action === 'remove') {
            //removes the breadcrumb
            $(`[data-js-active-filter-button][data-value="${value}"]`).remove();
        }
        else {
            //creates the breadcrumb at the top
            this.createActiveFilterButton(name, value, valueLabel);
        }
    }

    createActiveFilterButton(name, value, valueLabel) {
        const $activeFiltersContainer = $('[data-js-active-filters]');
        $activeFiltersContainer.append(
        `<button class="subcategory__active-filters__filter" data-js-active-filter-button data-name="${name}" data-value="${value}">
            <span class="subcategory__active-filters__name">${name}:</span>
            <span class="subcategory__active-filters__value">${valueLabel}</span>
            <span class="icomoon icomoon--Close"></span>
        </button>`
        );
        setTimeout(() => {
            // attach event listener to breadcrumb created in previous step. Essentially it unchecks the checkbox manually and triggers a 'change' to call the other onchange listener
            $(`[data-js-active-filter-button][data-value="${value}"]`).on('click', function() {
                $(`input[type="checkbox"][value="${value}"]`)
                .prop('checked', false)
                .trigger('change');
            });
        }, 50);
    }

    // onFilter(name, value) {}

    eachFilterInput(cb) {
        each(this.$filters, (filter) => {
            const
                $filter = $(filter),
                targetFilter = $filter.data('filter'),
                targetFilterName = $filter.data('filter-name');
            const $inputs = $(filter).find(`[name="${targetFilter}"]`);

            $inputs.each((idx, input) => {
                cb(input, filter, targetFilter, targetFilterName);
            });
        });
    }

    reset() {
        this.eachFilterInput((input, filter) => {
            if (input.type === "checkbox" && input.checked === true) {
                input.checked = false;
                $(input).trigger('input');

            // handles text and select
            } else if (input.type === "text" && input.value && input.value !== '') {
                const cmp = DomComponent.getComponentByRef($(filter).data('ref'));
                cmp.setValue(null); // this needs to be set to the default since this wipes out the category
            }
        });

        $('[data-js-active-filter-button]').remove();
        this.onReset();
    }

    /**
     * Update the filter DOM elements to match the filter model.
     * @param filterModel The filter model.
     */
    updateFilters(filterModel) {
        let key, value, valueLabel, checked;
        this.eachFilterInput((input, filter) => {
            key = filter.getAttribute('data-filter');
            if (input.type === 'checkbox') {
                value = input.value;
                valueLabel = $(input).data('value-label');
                checked = filterModel[key] && filterModel[key].some(x => x === value);
                input.checked = checked;

                // if the input is selected, automatically open the accordion of the parent and add class 'open'
                if (input.checked) {

                    let fieldName = $(input).closest(".form__field").data('filter-name');
                    this.createActiveFilterButton(fieldName, value, valueLabel);
                    $(`input[type="checkbox"][value="${value}"][name="${input.name}"]`)
                        .closest('[data-js-content]')
                        .slideDown()
                        .prev()
                        .addClass('open');
                }
            }
        });
    }

    updateDom() {}
}
